import { z } from "zod";
import { Color } from "../shared/colors";
import { BaseOverlayConfig } from "../shared/config";
import { defineOverlay } from "../shared/functions";
const backgroundColors = [
    Color.DEFAULT_RED,
    Color.LIGHT_PURPLE,
    Color.DARK_PURPLE,
    Color.LIGHT_BLUE,
    Color.DARK_BLUE,
    Color.LIGHT_AQUA,
    Color.DARK_AQUA,
    Color.LIGHT_GREEN,
    Color.DARK_GREEN,
    Color.LIGHT_YELLOW,
    Color.DARK_YELLOW,
];
const types = ["3d", "rounded", "slanted"];
export const VerticalProgressBar = defineOverlay({
    defaults: {
        backgroundColor: Color.DEFAULT_RED,
        type: "rounded",
    },
    details: {
        category: "progress",
        description: "Utilize our Vertical overlay to enhance your Tiltify fundraising campaign. Easily track the progress of your fundraising campaign.",
        features: [
            "Fits well into any streaming layouts",
            "Easily see the progress of your campaign",
            "Customize progress bar to match your own look and feel",
        ],
        flags: {
            isFeatured: false,
            isNew: false,
            isUpdated: false,
            isVisible: true,
        },
        icon: "progress-bars/vertical.png",
        name: "Vertical Progress Bar",
        obsDimensions: {
            height: "980px",
            width: "300px",
        },
        path: "/overlays/vertical/",
        shortDescription: "Track the progress of your fundraising campaign.",
        shortName: "Vertical",
        slug: "vertical",
    },
    schema: BaseOverlayConfig.extend({
        backgroundColor: z
            .enum(backgroundColors)
            .default(() => VerticalProgressBar._config.defaults.backgroundColor)
            .optional(),
        type: z
            .enum(types)
            .default(() => VerticalProgressBar._config.defaults.type)
            .optional(),
    }),
});
//# sourceMappingURL=vertical.js.map